import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  IconModule,
  MediaModule,
  OutletModule,
} from '@spartacus/storefront';
import { I18nModule,  } from '@spartacus/core';

import { UigAvailabilityComponent } from './uig-availability.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    I18nModule,
    IconModule,
    MediaModule,
    OutletModule,
  ],
  declarations: [
    UigAvailabilityComponent
  ],
  exports: [UigAvailabilityComponent],
})
export class UigAvailabilityModule {}
